import React, { useEffect, useRef, useState } from "react";
import { TextBox } from "devextreme-react/text-box";
import LV_ART_Articulos_SelectorConGrid_Selector from "./LV_ART_Articulos_SelectorConGrid_Selector";
import LVButtonAccion from "../../../Basicos/LVButtonAccion";
import ComboAbmEexPersonasAutorizantes from "../../../Compuestos/Combos/ComboAbmEexPersonasAutorizantes";
import LV_ART_Articulos_SelectorConGrid_Grid from "./LV_ART_Articulos_SelectorConGrid_Grid";
import LVBonificacionesRecargos from "../Operaciones/LVBonificacionesRecargos";
import LVConceptoObservaciones from "../Operaciones/LVConceptoObservaciones";
import { function_ABM_EEX_Personas_Leer } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_Personas";
import { function_ABM_ART_Articulos_CodigosBarra_LeerPorCodigoBarras } from "neftis7_apicaller/src/funciones/ABM/ART/ABM_ART_Articulos_CodigosBarra";
import { function_ABM_ART_Articulos_LeerPrecio } from "neftis7_apicaller/src/funciones/ABM/ART/ABM_ART_Articulos";
import RadioGroup from "devextreme-react/radio-group";
import { NumberBox } from "devextreme-react";

function LV_ART_Articulos_SelectorConGrid({ idEEX, esCompras, esVentas, codigoListaPrecios,
  tieneEnCuentaLPdelCliente, codigoMonedaEnviadaPorDocumento,
  tienePresentaciones = false, tieneTamanos = false, tieneUnidadesMedida = false,
  DatosDetalle, DatosConceptoObservaciones, setDatosDetalle, setDatosConceptoObservaciones,
  IdItemMasAlto = 1, muestraComponentesDelTotal = true, jsonParaAgregarDesdeAfuera, onTotalImporteDelComponenteChange,
  Comprables = false, Vendibles = false, Fabricables = false, Stockeables = false, Servicios = false,
  ExcluirVendibles = false, ExcluirComprables = false, ExcluirFabricables = false, ExcluirStockeables = false, ExcluirServicios = false,
  PermiteVisualizarStock = true, PermiteVenderConPrecioCero = false, CodigoTipoDoc = 1, pageSize,
  PuedeModificarPrecios = true, Comportamiento = 1 }) {

  const [articulosAgregados, setArticulosAgregados] = useState(DatosDetalle);
  const [objetoParaAgregarPadre, setObjetoParaAgregarPadre] = useState([]);
  const [contadorId, setContadorId] = useState(IdItemMasAlto);
  const [actualizarGrilla, setActualizarGrilla] = useState(false);
  const [porcentajeBonificacion, setPorcentajeBonificacion] = useState(0);
  const [idDocVentaSena, setIdDocVentaSena] = useState(0);
  const [importeSena, setImporteSena] = useState(0);
  const [porcentajeRecargo, setPorcentajeRecargo] = useState(0);
  const [mostrarAutorizacion, setMostrarAutorizacion] = useState(false);
  const [idPersonaBonificacionAutorizante, setIdPersonaBonificacionAutorizante] = useState(null);
  const [passwordBonificacion, setPasswordBonificacion] = useState("");
  const [codigoBarrasArticulo, setCodigoBarrasArticulo] = useState("");
  const codigoBarrasArticuloRef = useRef(null);
  const [comportamientoSena, setComportamientoSena] = useState(1);

  const handleAgregarOnClick = () => {
    if (objetoParaAgregarPadre.CodigoPresentacion === "") {
      alert("Error: Se debe completar la Presentación.");
      return;
    }
    if (objetoParaAgregarPadre.CodigoTamano === "") {
      alert("Error: Se debe completar el Tamaño.");
      return;
    }
    if (objetoParaAgregarPadre.CodigoUnidadMedida === "") {
      alert("Error: Se debe completar la Unidad de Medida.");
      return;
    }
    if (objetoParaAgregarPadre.CodigoArticulo === "") {
      alert("Error: Se debe completar el Artículo.");
      return;
    }
    if (objetoParaAgregarPadre.Cantidad === "" || objetoParaAgregarPadre.Cantidad === 0) {
      alert("Error: La Cantidad debe ser mayor a CERO.");
      return;
    }
    if (objetoParaAgregarPadre.ImporteNeto === "" || objetoParaAgregarPadre.ImporteNeto === 0) {
      if (!PermiteVenderConPrecioCero) {
        alert("Error: El Importe debe ser mayor a CERO.");
        return;
      }
    }

    const objetoConId = { ...objetoParaAgregarPadre, id: contadorId }; // Agregamos el campo id
    setArticulosAgregados([...articulosAgregados, objetoConId]);
    setContadorId(contadorId + 1); // Incrementamos el contador

    setActualizarGrilla(true)
  };

  const confirmarAutorizacionBonificacion = async () => {
    if (!idPersonaBonificacionAutorizante) {
      alert("Debe seleccionar quién autoriza.");
      return;
    }

    if (!passwordBonificacion) {
      alert("Debe ingresar una contraseña válida.");
      return;
    }

    const resultPersonaAutorizante = await function_ABM_EEX_Personas_Leer(idPersonaBonificacionAutorizante)
    if (passwordBonificacion !== resultPersonaAutorizante.data.Password) {
      alert("Contraseña inválida.")
      return
    }

    const updatedDataSource = articulosAgregados.map(row => {
      const IBonificado = (row.ImporteNeto / 100) * porcentajeBonificacion;
      return { ...row, ImporteBonificaciones: IBonificado };
    });

    setArticulosAgregados(updatedDataSource);
    setMostrarAutorizacion(false);
    setIdPersonaBonificacionAutorizante(null);
    setPasswordBonificacion("");
    setActualizarGrilla(true);
  };

  const handleOnClickAplicar = () => {
    setMostrarAutorizacion(true);
  };

  const handleOnClickBorrar = () => {
    const updatedDataSource = articulosAgregados.map(row => {
      return { ...row, ImporteBonificaciones: 0 };
    });
    setArticulosAgregados(updatedDataSource);
  };

  const handleChangeBonificacion = (value) => {
    setPorcentajeBonificacion(value);
  };

  const handleChangeRecargo = (value) => {
    setPorcentajeRecargo(value);
  };

  const handleOnFocusOut_CodigoBarrasArticulo = async () => {
    if (!codigoBarrasArticulo) return;

    try {
      const resultArticulo = await function_ABM_ART_Articulos_CodigosBarra_LeerPorCodigoBarras(codigoBarrasArticulo)

      const data = resultArticulo.data?.[0];
      if (!data) throw new Error("Artículo no encontrado");

      const { CodigoArticulo, I_DescripcionArticulo,
        CodigoPresentacion, I_DescripcionPresentacion,
        CodigoTamano, I_DescripcionTamano,
        CodigoUnidadMedida, I_DescripcionUnidadMedida } = data;

      const resultPrecio = await function_ABM_ART_Articulos_LeerPrecio(
        CodigoArticulo,
        CodigoPresentacion || "DEF",
        CodigoTamano || "DEF",
        CodigoUnidadMedida || "UN",
        idEEX,
        0, 1,
        codigoListaPrecios,
        true,
        "PA"
      );

      const precios = resultPrecio.data;
      const cantidad = 1;
      const tiposDocSinIVA = [41, 42, 43, 71, 72, 73];
      const PorcentajeIVA = tiposDocSinIVA.includes(CodigoTipoDoc) ? 0 : precios.PorcentajeIVA;
      const PorcentajeImpuestosInternos = precios.PorcentajeImpuestosInternos || 0;

      const ImporteNeto = precios.ImporteNeto;
      const ImporteBonificaciones = precios.ImporteBonificacion;
      const ImporteRecargos = precios.ImporteRecargo;
      const ImporteSubTotal = ImporteNeto - ImporteBonificaciones + ImporteRecargos;
      const ImporteIVA = ImporteSubTotal * PorcentajeIVA / 100;
      const ImporteImpuestosInternos = ImporteSubTotal * PorcentajeImpuestosInternos / 100;
      const ImporteTotal = ImporteSubTotal + ImporteIVA + ImporteImpuestosInternos;

      const item = {
        CodigoArticulo,
        CodigoCompania: localStorage.getItem("CodigoCompania"),
        CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
        CodigoPlanta: localStorage.getItem("CodigoPlanta"),
        Articulo: I_DescripcionArticulo,
        Observaciones: I_DescripcionArticulo,
        CodigoPresentacion,
        Presentacion: I_DescripcionPresentacion,
        CodigoTamano,
        Tamano: I_DescripcionTamano,
        CodigoUnidadMedida,
        UnidadMedida: I_DescripcionUnidadMedida,
        Cantidad: cantidad,
        ImporteNeto,
        ImporteNetoTotal: ImporteNeto * cantidad,
        ImporteBonificaciones,
        ImporteBonificacionesTotal: ImporteBonificaciones * cantidad,
        ImporteDescuentos: ImporteBonificaciones,
        ImporteDescuentosTotal: ImporteBonificaciones * cantidad,
        ImporteRecargos,
        ImporteRecargosTotal: ImporteRecargos * cantidad,
        ImporteSubTotal,
        ImporteSubTotalTotal: ImporteSubTotal * cantidad,
        ImporteIVA,
        ImporteIVATotal: ImporteIVA * cantidad,
        ImporteImpuestosInternos,
        ImporteImpuestosInternosTotal: ImporteImpuestosInternos * cantidad,
        ImporteTotal,
        ImporteTotalTotal: ImporteTotal * cantidad,
        IdItemCotizacion: 0,
        IdItemPedido: 0,
        IdItemRemito: 0,
        PorcentajeIVA,
        PorcentajeImpuestosInternos
      };

      const objetoConId = { ...item, id: contadorId };
      setArticulosAgregados(prev => [...prev, objetoConId]);
      setContadorId(contadorId + 1);
      setActualizarGrilla(true);
    } catch (error) {
      alert("Error: " + error)
    } finally {
      // Le devuelve el foco
      setTimeout(() => {
        setCodigoBarrasArticulo("")
        codigoBarrasArticuloRef.current?.instance?.focus();
      }, 0);
    }
  };

  const handleOnClickGuardarSena = () => {
    try {
      if (!importeSena || importeSena < 1) {
        alert("Debe cargar un importe válido")
        return;
      }

      alert("Se ha guardado la Seña")
    } catch (error) {
      alert("Error: " + error)
    }
  };

  const handleOnClickDevolverSena = () => {
    try {
      if (!idDocVentaSena || idDocVentaSena < 1) {
        alert("Debe cargar un código válido")
        return;
      }

      alert("Se ha devuelto la Seña")
    } catch (error) {
      alert("Error: " + error)
    }
  };

  useEffect(() => {
    if (jsonParaAgregarDesdeAfuera && Object.keys(jsonParaAgregarDesdeAfuera).length > 0) {
      const objetoConId = { ...jsonParaAgregarDesdeAfuera, id: contadorId }; // Agregamos el campo id
      setArticulosAgregados([...articulosAgregados, objetoConId]);
      setContadorId(contadorId + 1); // Incrementamos el contador
      setActualizarGrilla(true);
    }
  }, [jsonParaAgregarDesdeAfuera]);

  useEffect(() => {
    setDatosDetalle(articulosAgregados)
  }, [articulosAgregados]);

  useEffect(() => {

    if (DatosDetalle && DatosDetalle.length > 0) {
      setActualizarGrilla(true);
    }
  }, []);

  useEffect(() => {
    if (DatosDetalle && DatosDetalle.length > 0) {
      const articulosAgregadosNew = DatosDetalle;
      setArticulosAgregados(articulosAgregadosNew)
      setActualizarGrilla(true);
    }
  }, [DatosDetalle]);

  useEffect(() => {
    setActualizarGrilla(true);
  }, [CodigoTipoDoc]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', overflowX: 'auto', overflowY: 'auto' }}>

      {Comportamiento == 3 && (
        <div className="LV-GroupBox-div LV-FlexContainer" style={{ margin: '5px', padding: '10px', display: 'flex', gap: '5px' }}>
          <div style={{ marginLeft: '1px', marginRight: '70px' }}>
            <RadioGroup
              items={[
                { text: "Emisión", value: 1 },
                { text: "Devolución", value: 2 }
              ]}
              value={comportamientoSena}
              onValueChanged={(e) => setComportamientoSena(e.value)}
              layout="horizontal"
              valueExpr="value"
              displayExpr="text"
            />
          </div>

          {comportamientoSena === 1 && (
            <>
              Importe
              <NumberBox value={importeSena} onValueChanged={(e) => setImporteSena(e.value)} />
              <LVButtonAccion Texto={"GUARDAR"} onClick={handleOnClickGuardarSena} />
            </>
          )}

          {comportamientoSena === 2 && (
            <>
              Código
              <NumberBox value={idDocVentaSena} onValueChanged={(e) => setIdDocVentaSena(e.value)} />
              <LVButtonAccion Texto={"DEVOLVER"} onClick={handleOnClickDevolverSena} />
            </>
          )}
        </div>
      )}

      {/* Selector Component */}
      {Comportamiento != 0 && Comportamiento != 2 && Comportamiento != 3 && (
        <div style={{ margin: '5px', padding: '0px', display: 'flex' }}>
          <div style={{ flex: 1 }}>
            <LV_ART_Articulos_SelectorConGrid_Selector
              idEEX={idEEX}
              esCompras={esCompras}
              esVentas={esVentas}
              codigoListaPrecios={codigoListaPrecios}
              tieneEnCuentaLPdelCliente={tieneEnCuentaLPdelCliente}
              codigoMonedaEnviadaPorDocumento={codigoMonedaEnviadaPorDocumento}
              objetoParaAgregar={objetoParaAgregarPadre}
              actualizarObjetoParaAgregar={setObjetoParaAgregarPadre}
              tienePresentaciones={tienePresentaciones}
              tieneTamanos={tieneTamanos}
              tieneUnidadesMedida={tieneUnidadesMedida}
              onClickAgregar={handleAgregarOnClick}
              muestraComponentesDelTotal={muestraComponentesDelTotal}
              Comprables={Comprables}
              Vendibles={Vendibles}
              Fabricables={Fabricables}
              Stockeables={Stockeables}
              Servicios={Servicios}
              ExcluirVendibles={ExcluirVendibles}
              ExcluirComprables={ExcluirComprables}
              ExcluirFabricables={ExcluirFabricables}
              ExcluirStockeables={ExcluirStockeables}
              ExcluirServicios={ExcluirServicios}
              PermiteVisualizarStock={PermiteVisualizarStock}
              PuedeModificarPrecios={PuedeModificarPrecios}
              CodigoTipoDoc={CodigoTipoDoc} />
          </div>
        </div>
      )}

      {Comportamiento == 2 && (
        <div className="LV-GroupBox-div LV-FlexContainer" style={{ margin: '5px', padding: '10px', display: 'flex' }}>
          Código de Barras     <TextBox
            width={300}
            value={codigoBarrasArticulo}
            onValueChanged={(e) => setCodigoBarrasArticulo(e.value)}
            onFocusOut={handleOnFocusOut_CodigoBarrasArticulo}
            ref={codigoBarrasArticuloRef}
          />
        </div>
      )}

      {/* Grid Component */}
      {Comportamiento != 3 && (
        <div style={{ margin: '5px', padding: '0px', display: 'flex' }}>
          <LV_ART_Articulos_SelectorConGrid_Grid
            dataSource={articulosAgregados}
            tienePresentaciones={tienePresentaciones}
            tieneTamanos={tieneTamanos}
            tieneUnidadesMedida={tieneUnidadesMedida}
            actualizarGrilla={actualizarGrilla}
            onTotalImporteDelComponenteChange={onTotalImporteDelComponenteChange}
            muestraComponentesDelTotal={muestraComponentesDelTotal}
            CodigoTipoDoc={CodigoTipoDoc}
            pageSize={pageSize} />
        </div>
      )}

      {/* Row with BonificacionesRecargos and ConceptoObservaciones */}
      <div style={{ display: 'flex', width: '100%' }}>
        {Comportamiento != 3 && (
          <div style={{ width: '30%', margin: '0px', padding: '5px' }}>
            <LVBonificacionesRecargos
              onClickAplicar={handleOnClickAplicar}
              onClickBorrar={handleOnClickBorrar}
              onChangeBonificacion={handleChangeBonificacion}
              onChangeRecargo={handleChangeRecargo} />
          </div>
        )}
        <div style={{ width: '70%', margin: '0px', padding: '5px' }}>
          <LVConceptoObservaciones
            DatosConceptoObservaciones={DatosConceptoObservaciones}
            setDatosConceptoObservaciones={setDatosConceptoObservaciones} />
        </div>
      </div>

      {/* Autorizacion de Bonificaciones */}
      {mostrarAutorizacion && (
        <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
          <label>Autoriza:</label>
          <ComboAbmEexPersonasAutorizantes
            value={idPersonaBonificacionAutorizante}
            onValueChanged={(e) => setIdPersonaBonificacionAutorizante(e.value)}
            PuedeAutorizarDescuentos={true}
          />
          <label>Contraseña:</label>
          <TextBox
            mode="password"
            value={passwordBonificacion}
            onValueChanged={(e) => setPasswordBonificacion(e.value)}
            width={200}
          />
          <LVButtonAccion
            Texto="CONFIRMAR"
            onClick={confirmarAutorizacionBonificacion}
          />
          <LVButtonAccion
            Texto="CANCELAR"
            onClick={() => setMostrarAutorizacion(false)}
          />
        </div>
      )}
    </div>
  );
}

export default LV_ART_Articulos_SelectorConGrid